import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  AccountBalance,
  Add,
  List,
  Approval,
  AdminPanelSettings,
} from "@mui/icons-material";

const BudgetsPage = () => {
  const navigate = useNavigate();

  const budgetModules = [
    {
      title: "Budget Periods",
      description: "Manage budget periods and submission deadlines",
      icon: <AccountBalance color="primary" />,
      path: "/budgets/periods",
      permission: "VIEW_BUDGET_PERIODS",
    },
    {
      title: "Create Budget",
      description: "Create new budgets for your department",
      icon: <Add color="success" />,
      path: "/budgets/create",
      permission: "CREATE_BUDGET",
    },
    {
      title: "View Budgets",
      description: "View and manage existing budgets",
      icon: <List color="info" />,
      path: "/budgets",
      permission: "VIEW_BUDGETS",
    },
    {
      title: "Finance Approvals",
      description: "Approve or reject submitted budgets",
      icon: <Approval color="warning" />,
      path: "/budgets/finance/approvals",
      permission: "FINANCE_APPROVE_BUDGET",
    },
    {
      title: "Admin Approvals",
      description: "Final budget approval by administrators",
      icon: <AdminPanelSettings color="error" />,
      path: "/budgets/admin/approvals",
      permission: "ADMIN_APPROVE_BUDGET",
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Budget Management System
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Complete budget management workflow from creation to final approval.
      </Typography>

      <Grid container spacing={3}>
        {budgetModules.map((module, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  {module.icon}
                  <Typography variant="h6" sx={{ ml: 1 }}>
                    {module.title}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {module.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  onClick={() => navigate(module.path)}
                  fullWidth
                >
                  Access
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BudgetsPage;
